import { Drawer, Grid, Typography, TextField as MUITextField, Divider } from '@material-ui/core';
import { Button, SmSpace } from 'm2m.components';
import React from 'react';
import RemoveIcon from '@material-ui/icons/Remove';
import { Custodiante } from 'common/genericTypes';

interface Props {
  open: boolean;
  custodiante: Custodiante | null;
  onClose: () => void;
  removeInvestidor: (cpfCnpj: string) => void;
  isEdit: boolean;
}

const InvestidoresListDrawer: React.FC<Props> = (props) => {
  const { open, custodiante, isEdit, onClose, removeInvestidor } = props;

  const handleClose = () => {
    onClose();
  };



  return (
    <Drawer open={open} onClose={handleClose} PaperProps={{ style: { padding: '40px', width: 465 } }} anchor="right">
      <Typography variant="h3">{'Lista de Investidores'}</Typography>
      <Typography variant="body2">{custodiante?.razaoSocialInstituicaoCustodiante}</Typography>
      <SmSpace />
      <Divider variant="fullWidth" />
      <SmSpace />
      <Grid container spacing={2} style={{ width: '100%' }}>
        <Grid item xs={12}>
          {custodiante?.investidoresPrivados.map((investidor) => {
            return (
              <>
                <Grid item xs={12} style={{ display: 'flex', flexDirection: 'row' }}>
                  <Grid item xs={10}>
                    <Typography variant="body1">{'Razão Social'}</Typography>
                    <Typography variant="body2">{investidor.razaoSocial}</Typography>
                    <Typography variant="body1">{'CPF / CNPJ'}</Typography>
                    <Typography variant="body2">{investidor.cpfCnpj}</Typography>
                    <Typography variant="body1">{'Quantidade'}</Typography>
                    <Typography variant="body2">
                      {Number(investidor.quantidade).toLocaleString('pt-BR', {
                        minimumFractionDigits: 8,
                        maximumFractionDigits: 8,
                        useGrouping: false
                      })}

                    </Typography>
                  </Grid>
                  {(
                    <Grid item xs={2} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <Button
                        variant="contained"
                        color="error"
                        onClick={() => {
                          removeInvestidor(investidor.cpfCnpj);
                        }}
                        style={{ minWidth: '0', maxWidth: '45px', width: '45px', height: '60px', borderRadius: '50%' }}
                      >
                        <RemoveIcon />
                      </Button>
                    </Grid>
                  )}
                </Grid>
                <SmSpace />
              </>
            );
          })}
        </Grid>
        {custodiante?.investidoresPrivados.length === 0 ? (
          <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Typography variant="body2">{'Nenhum investidor'}</Typography>
          </Grid>
        ) : (
          <></>
        )}
      </Grid>
    </Drawer>
  );
};

export default InvestidoresListDrawer;
